import { defineFcm } from '../shared/factory';

export const FCM_GOOGLE_AUTH = defineFcm('google_auth').asBoolean().withDefault(false).toConfig({
	owner: 'squad-site-platform',
	scope: 'corgi-front-end',
	context: 'Login / Sign up',
	description: 'If true, a Google Auth button will be displayed on the login/signup pages and modals.',
	import: false,
});
